import { VertSpacerMd } from '@apps-common/components/layout'

export const UnitFirmwareCardSkeleton = () => (
  <div className='p-6 w-full rounded-3xl bg-skeleton border border-skeleton-border animate-pulse'>
    <div className='w-full flex items-center justify-end gap-[5px] mb-[5px]'>
      <div className='avatar'>
        <div className='!flex w-9 items-center justify-center rounded-full bg-skeleton-hi' />
      </div>
      <div className='avatar'>
        <div className='!flex w-9 items-center justify-center rounded-full bg-skeleton-hi' />
      </div>
    </div>
    <div className='bg-skeleton-hi w-[50%] h-[20px] rounded-[10px]' />
    <VertSpacerMd />
    <div className='bg-skeleton-hi w-[80%] h-[20px] rounded-[10px]' />
  </div>
)
